<template>
  <v-app>
    <confirm-dialog ref="confirm"></confirm-dialog>
    <router-view/>
  </v-app>
</template>

<script>
import ConfirmDialog from '@/components/Common/ConfirmDialog.vue'
export default {
  data() {
    return {
      logoutTimer: null, // Main inactivity timer
      activityEvents: ["mousemove", "keydown", "scroll", "click"], // Events to track activity
      inactivityDuration: 60 * 60 * 1000, //  60 minutes in milliseconds
      lastActivityKey: "lastActivityTimestamp", // Key for localStorage
    };
  },
  components:[
    ConfirmDialog
  ],
  provide() {
    return {
      $confirm: this.$confirm,
    };
  },
  methods: {
    $confirm(){
      return this.$refs.confirm.open(title, message, options);
    },
    startLogoutTimer() {
      // Clears the existing timer and starts a new one
      this.clearLogoutTimer();

      // Save the current timestamp in localStorage
      localStorage.setItem(
        this.lastActivityKey,
        Date.now().toString()
      );

      // Set a timeout for the logout
      // this.logoutTimer = setTimeout(this.handleLogout, this.inactivityDuration);
      if(this.logoutTimer == null){
        this.logoutTimer = setInterval(this.checkInactivity, 1000);
      }
    },
    clearLogoutTimer() {
      // Clear the existing timer
      if (this.logoutTimer) {
        clearTimeout(this.logoutTimer);
        this.logoutTimer = null;
      }
    },
    handleActivity() {
      localStorage.setItem(
        this.lastActivityKey,
        Date.now().toString()
      );
    },
    handleLogout() {
      if(this.$store.state.token == null)
        return;
      
      this.$axios
        .get("/admin/logout", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.$store.commit("setToken", null);
          this.$store.commit("setUser", null);
          this.$router.push({ name: "Login" });
          this.$toast.warning('You have been logged out');
        });
    },
    checkInactivity() {
      if(this.$store.state.token == null || this.$route.name == 'Login'){
        return;
      }
      
      // Reset the timer on user activity
      // Check the last activity timestamp from localStorage
      const lastActivity = parseInt(
        localStorage.getItem(this.lastActivityKey),
        10
      );

      if (isNaN(lastActivity)) {
        // If there's no valid timestamp, treat it as expired and log the user out
        this.handleLogout();
        return;
      }

      const now = Date.now();
      const timeSinceLastActivity = now - lastActivity;

      if (timeSinceLastActivity > this.inactivityDuration) {
        // If the user has been inactive for too long, log them out
        this.handleLogout();
      }
    },
  },
  mounted() {
    if(process.env.VUE_APP_ENV_TYPE == 'prod'){
      // Add event listeners for user activity
      this.activityEvents.forEach((event) =>
        window.addEventListener(event, this.handleActivity)
      );
  
      this.startLogoutTimer();
    }
  },
  beforeDestroy() {
    // Clean up event listeners and timers when the component is destroyed
    this.clearLogoutTimer();
    this.activityEvents.forEach((event) =>
      window.removeEventListener(event, this.handleActivity)
    );
    document.removeEventListener("visibilitychange", this.startLogoutTimer);
  },
};
</script>

<style>
.component-title {
  background-color: #1C3B68;
  color: white;
  text-transform: uppercase;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: .0125em;
  line-height: 2rem;
  word-break: break-all;
}

.component-title h4 {
  text-align: center;
}

.expansion-header-title {
  color: white;
  text-transform: uppercase;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem !important;
  letter-spacing: .0125em !important;
  line-height: 2rem;
  word-break: break-all;
  font-weight: 500;
}

.left-sidebar .v-list-item__action,
.left-sidebar .v-list-item__icon {
  margin-right: 15px !important;
}

.left-sidebar .v-list-group__items {
  padding-left: 15px !important;
}

.theme--light.v-application {
  background: #f5f5f5 !important;
}

.nav-left-custom .v-list-item--link:before,
.menu-top .v-list-item--link:before {
  border-right: 6px solid #145aa5;
  color: #ffff;
  background: linear-gradient(270deg, #145aa5 0%, #145aa5 100%);
}

.nav-left-custom .v-list-item--link:before,
.nav-left-custom .v-list-item__action,
.menu-top .v-list-item--link:before,
.menu-top .v-list-item__action {
  color: #145aa5;
}

/*.v-application a {*/
/*    color: #145aa5 !important;*/
/*}*/
.nav-height {
  max-height: calc(100% - 24px) !important;
  margin-right: 10px;
  /*  width: 270px !important; */
  /* height: calc(100% - 32px) !important; */
}

.child-nav-height {
  max-height: 100% !important;
  /*  left: 300px;
  top: 85px !important;
  */
}

.user-img {
  height: 40px;
  width: 40px;
  border-radius: 50%;
}

header.menu-top {
  box-shadow: none !important;
  background: #ffffff !important;
}

#notification {
  max-width: 350px !important;
  width: 100% !important;
}

.link-hover:hover {
  color: #ffffff !important;
  background-position: left;
}

.link-hover {
  background: linear-gradient(to left, #ffffff 50%, #145aa5 50%) right;
  background-size: 205%;
  transition: 0.5s ease-out;
  color: #6200ea !important;
  border-top: 2px solid #e0e0e0 !important;
}
</style>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.5s;
}

.page-enter,
.page-leave-to {
  opacity: 0;
}

.layout-enter-active,
.layout-leave-active {
  transition: opacity 0.5s;
}

.layout-enter,
.layout-leave-to {
  opacity: 0;
}

.slide-bottom-enter-active,
.slide-bottom-leave-active {
  transition: opacity 0.25s ease-in-out, transform 0.25s ease-in-out;
}

.slide-bottom-enter,
.slide-bottom-leave-to {
  opacity: 0;
  transform: translate3d(0, 15px, 0);
}

.bounce-enter-active {
  transform-origin: top;
  animation: bounce-in 0.8s;
}

.bounce-leave-active {
  transform-origin: top;
  animation: bounce-out 0.5s;
}

.badge-notification {
  z-index: 99999999;
  position: absolute;
  transform: translate(5px, -5px);
}

.badge-employee {
  z-index: 99999999;
  position: absolute;
  transform: translate(10px, 0px);
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bounce-out {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(0);
  }
}

.world_sidebar_logo {
  height: auto !important;
  width: 100%;
  text-align: left;
}

.v-list-item__title.title img {
  width: 180px !important;
  text-align: left;
}
</style>
